import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../../../assets/widget-shared.scss';
import { styles as flexboxHelpersStyles } from '../../../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../../../assets/text-helpers.scss';
import { LabelWidthValues } from '../../../../../types/common/types';

export const templateReconfigureAgentSchedulerForm = document.createElement('template');

templateReconfigureAgentSchedulerForm.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id='reconfigure-agent-scheduler-form-wrapper'>
    <div class='form-section'>
      <gz-form-field id='reconfigure-scheduler-options' class='label-mw-150' label=''>
        <gz-radio-group id='reconfigure-scheduler-options-group' gz-form-input >
          <gz-radio id='reconfigure-scheduler-now' class='mb-3'></gz-radio>
          <gz-radio id='reconfigure-scheduler-scheduled' class='mb-2'></gz-radio>
        </gz-radio-group>
      </gz-form-field>

      <div id='scheduled-section' class='hidden'>
        <gz-form-field id='recurrence-form-field' class='label-mw-250 ml-3 mb-1'>
          <gz-dropdown gz-form-input type='dropdown' labelWidth='${LabelWidthValues.MEDIUM}'></gz-dropdown>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field id='recurrence-evey-day-form-field' class='label-mw-250 ml-3 mb-1 hidden' required>
          <gz-input-number gz-form-input min='1' max='23'></gz-input-number>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field id='recurrence-weekly-select-form-field' class='label-mw-250 ml-3 mb-1 hidden' required>
          <gz-multiselect-group gz-form-input></gz-multiselect-group>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field id='recurrence-start-time-form-field' class='label-mw-250 ml-3 mb-1 hidden' required>
          <gz-time-picker gz-form-input></gz-time-picker>
          <gz-input-error></gz-input-error>
        </gz-form-field>
      </div>
    </div>
  </div>
`;
